/**
 * Loot pool configurations
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.993Z
 */

import { ConfigType } from './ConfigType';

export interface LootPoolConfig {
  loot_pool_id: string;
  rolls: number;
  pity_kind: string | null;
  pity_N: number | null;
  notes: string;
  configType: ConfigType.LOOT_POOLS;
}

export const lootPoolsData: Record<string, LootPoolConfig> = {
  LP_COMMON: {
    loot_pool_id: 'LP_COMMON',
    rolls: 1,
    pity_kind: null,
    pity_N: null,
    notes: 'базовый «каменный» пул',
    configType: ConfigType.LOOT_POOLS,
  },
  LP_QUARTZ: {
    loot_pool_id: 'LP_QUARTZ',
    rolls: 1,
    pity_kind: null,
    pity_N: null,
    notes: 'кварцевый пул',
    configType: ConfigType.LOOT_POOLS,
  },
  LP_FERRO: {
    loot_pool_id: 'LP_FERRO',
    rolls: 1,
    pity_kind: null,
    pity_N: null,
    notes: 'железистый пул',
    configType: ConfigType.LOOT_POOLS,
  },
  LP_LUMEN: {
    loot_pool_id: 'LP_LUMEN',
    rolls: 1,
    pity_kind: null,
    pity_N: null,
    notes: 'люменитовый пул',
    configType: ConfigType.LOOT_POOLS,
  },
  LP_VEIN: {
    loot_pool_id: 'LP_VEIN',
    rolls: 2,
    pity_kind: 'item',
    pity_N: 10,
    notes: 'венозный узел; жалость на itm_neon_vein_shard',
    configType: ConfigType.LOOT_POOLS,
  },
  LP_SHARDS: {
    loot_pool_id: 'LP_SHARDS',
    rolls: 1,
    pity_kind: null,
    pity_N: null,
    notes: 'осколки от фрагментации',
    configType: ConfigType.LOOT_POOLS,
  },
};

/**
 * Get LootPoolConfig by loot_pool_id
 */
export function getLootPools(id: string): LootPoolConfig | undefined {
  return lootPoolsData[id];
}

/**
 * Get all LootPoolConfig entries
 */
export function getAllLootPools(): LootPoolConfig[] {
  return Object.values(lootPoolsData);
}

/**
 * Check if LootPoolConfig exists
 */
export function hasLootPools(id: string): boolean {
  return id in lootPoolsData;
}
